import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return (!!_vm.instance)?_c(VContainer,[_c('toolbar',{attrs:{"item":_vm.instance,"mode":"export"}}),_c(VCard,{attrs:{"flat":""}},[_c('ExportForm',{attrs:{"predictions":_vm.predictions,"connections":_vm.connections,"techniques":_vm.techniques,"instance":_vm.instance},on:{"submitted":_vm.onSubmit}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }